import React from "react";
import classNames from "classnames/bind"

import styles from "./clearfix.module.scss"

const cx = classNames.bind(styles)


export const Clearfix = () => {
    return (
        <div className={cx('clearfix')}></div>
    )
}